// extracted by mini-css-extract-plugin
module.exports = {"sale-callout-container":"callouts_sale-callout-container__S9d0K"};